import React from 'react';
import styles from './style.module.scss';
import { ReactComponent as ShieldIcon } from '../../../../assets/icons/Shield.svg';
import { ReactComponent as DocumentIcon } from '../../../../assets/icons/Document.svg';


export const StealthComparisonGraphic = () => {
  return (
    <div className={styles.graphicContainer}>
      <div className={styles.comparisonBox}>
        <div className={styles.comparisonItem}>
            <DocumentIcon className={styles.documentIcon} />
            <span className={styles.itemLabel}>Standard <br /> Text</span>
            <span className={styles.itemSublabel}>Detectable by AI</span>
        </div>
        <div className={styles.arrow}>→</div>
        <div className={`${styles.comparisonItem} ${styles.highlighted}`}>
            <ShieldIcon className={styles.shieldIcon} />
            <span className={styles.itemLabel}>Stealth <br /> Model</span>
            <span className={styles.itemSublabel}>Undetectable</span>
        </div>
      </div>
    </div>
  );
};
